export const CALENDLY_URL = 'https://calendly.com/parniaa/30min';
export const SITE_URL = 'https://www.mitrabehboudi.com';



